import React from "react";

import { ViewContainer } from "components/layout";

import PrimarySplitInfo from "./primarySplitInfo";
import SecondarySplitInfo from "./secondarySplitInfo";
import CommissionSplitInfo from "./splitsInformation";

import styles from "../commissionSplits.module.scss";

type CommissionSplitsViewProps = {
	initialValues: { [key: string]: any };
	isLoading: boolean;
};

const CommissionSplitsView = ({
	initialValues,
	isLoading,
}: CommissionSplitsViewProps) => {
	return (
		<ViewContainer className={styles.commissionSplitsViewContainer}>
			<CommissionSplitInfo
				isLoading={isLoading}
				initialValues={initialValues?.commissionSplitInfo || {}}
			/>
			<PrimarySplitInfo
				isLoading={isLoading}
				initialValues={initialValues?.primarySplitInformation || {}}
				secondarySplitInfoLength={
					initialValues?.secondarySplitInformation?.length
				}
			/>

			{initialValues?.secondarySplitInformation?.map(
				(splitInfo, index) => (
					<SecondarySplitInfo
						isLoading={isLoading}
						initialValues={splitInfo || {}}
						secondarySplitInformation={
							initialValues?.secondarySplitInformation
						}
						key={index}
						indexArray={index}
					/>
				),
			)}
		</ViewContainer>
	);
};

export default CommissionSplitsView;
